import React from "react";
import "./App.css";
import "./components/Variables.css";

import { ThemeProvider as SCThemeProvider } from "styled-components";
import { StylesProvider, useTheme } from "@material-ui/core/styles";

import Home from "./components/organismes/Home/Home.page";

import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

import ReactGA from "react-ga4";

function App() {
  const muiTheme = useTheme();
  const msalInstance = new PublicClientApplication(msalConfig);

  const TRACKING_ID = "G-FF385KLNDR";
  ReactGA.initialize(TRACKING_ID);

  return (
    <StylesProvider injectFirst>
      <SCThemeProvider theme={muiTheme}>
        <MsalProvider instance={msalInstance}>
          <div className="App">
            <Home />
          </div>
        </MsalProvider>
      </SCThemeProvider>
    </StylesProvider>
  );
}

export default App;
